import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserInfo } from 'src/store/user-info-context';
import SidebarLayout from './layouts/SidebarLayout';

const ProtectedRoute = () => {
  const { isAuthenticated } = useUserInfo();

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  return (
    <SidebarLayout>
      <Outlet />
    </SidebarLayout>
  );
};

export default ProtectedRoute;
